/**
 * DEVELOPER DOCUMENTATION
 *
 * Include your custom JavaScript here.
 *
 * The theme Focal has been developed to be easily extensible through the usage of a lot of different JavaScript
 * events, as well as the usage of custom elements (https://developers.google.com/web/fundamentals/web-components/customelements)
 * to easily extend the theme and re-use the theme infrastructure for your own code.
 *
 * The technical documentation is summarized here.
 *
 * ------------------------------------------------------------------------------------------------------------
 * BEING NOTIFIED WHEN A VARIANT HAS CHANGED
 * ------------------------------------------------------------------------------------------------------------
 *
 * This event is fired whenever a the user has changed the variant in a selector. The target get you the form
 * that triggered this event.
 *
 * Example:
 *
 * document.addEventListener('variant:changed', function(event) {
 *   let variant = event.detail.variant; // Gives you access to the whole variant details
 *   let form = event.target;
 * });
 *
 * ------------------------------------------------------------------------------------------------------------
 * MANUALLY CHANGE A VARIANT
 * ------------------------------------------------------------------------------------------------------------
 *
 * You may want to manually change the variant, and let the theme automatically adjust all the selectors. To do
 * that, you can get the DOM element of type "<product-variants>", and call the selectVariant method on it with
 * the variant ID.
 *
 * Example:
 *
 * const productVariantElement = document.querySelector('product-variants');
 * productVariantElement.selectVariant(12345);
 *
 * ------------------------------------------------------------------------------------------------------------
 * BEING NOTIFIED WHEN A NEW VARIANT IS ADDED TO THE CART
 * ------------------------------------------------------------------------------------------------------------
 *
 * This event is fired whenever a variant is added to the cart through a form selector (product page, quick
 * view...). This event DOES NOT include any change done through the cart on an existing variant. For that,
 * please refer to the "cart:updated" event.
 *
 * Example:
 *
 * document.addEventListener('variant:added', function(event) {
 *   var variant = event.detail.variant; // Get the variant that was added
 * });
 *
 * ------------------------------------------------------------------------------------------------------------
 * BEING NOTIFIED WHEN THE CART CONTENT HAS CHANGED
 * ------------------------------------------------------------------------------------------------------------
 *
 * This event is fired whenever the cart content has changed (if the quantity of a variant has changed, if a variant
 * has been removed, if the note has changed...). This event will also be emitted when a new variant has been
 * added (so you will receive both "variant:added" and "cart:updated"). Contrary to the variant:added event,
 * this event will give you the complete details of the cart.
 *
 * Example:
 *
 * document.addEventListener('cart:updated', function(event) {
 *   var cart = event.detail.cart; // Get the updated content of the cart
 * });
 *
 * ------------------------------------------------------------------------------------------------------------
 * REFRESH THE CART/MINI-CART
 * ------------------------------------------------------------------------------------------------------------
 *
 * If you are adding variants to the cart and would like to instruct the theme to re-render the cart, you cart
 * send the cart:refresh event, as shown below:
 *
 * document.documentElement.dispatchEvent(new CustomEvent('cart:refresh', {
 *   bubbles: true
 * }));
 *
 * ------------------------------------------------------------------------------------------------------------
 * USAGE OF CUSTOM ELEMENTS
 * ------------------------------------------------------------------------------------------------------------
 *
 * Our theme makes extensive use of HTML custom elements. Custom elements are an awesome way to extend HTML
 * by creating new elements that carry their own JavaScript for adding new behavior. The theme uses a large
 * number of custom elements, but the two most useful are drawer and popover. Each of those components add
 * a "open" attribute that you can toggle on and off. For instance, let's say you would like to open the cart
 * drawer, whose id is "mini-cart", you simply need to retrieve it and set its "open" attribute to true (or
 * false to close it):
 *
 * document.getElementById('mini-cart').open = true;
 *
 * Thanks to the power of custom elements, the theme will take care automagically of trapping focus, maintaining
 * proper accessibility attributes...
 *
 * If you would like to create your own drawer, you can re-use the <drawer-content> content. Here is a simple
 * example:
 *
 * // Make sure you add "aria-controls", "aria-expanded" and "is" HTML attributes to your button:
 * <button type="button" is="toggle-button" aria-controls="id-of-drawer" aria-expanded="false">Open drawer</button>
 *
 * <drawer-content id="id-of-drawer">
 *   Your content
 * </drawer-content>
 *
 * The nice thing with custom elements is that you do not actually need to instantiate JavaScript yourself: this
 * is done automatically as soon as the element is inserted to the DOM.
 *
 * ------------------------------------------------------------------------------------------------------------
 * THEME DEPENDENCIES
 * ------------------------------------------------------------------------------------------------------------
 *
 * While the theme tries to keep outside dependencies as small as possible, the theme still uses third-party code
 * to power some of its features. Here is the list of all dependencies:
 *
 * "vendor.js":
 *
 * The vendor.js contains required dependencies. This file is loaded in parallel of the theme file.
 *
 * - custom-elements polyfill (used for built-in elements on Safari - v1.0.0): https://github.com/ungap/custom-elements
 * - web-animations-polyfill (used for polyfilling WebAnimations on Safari 12, this polyfill will be removed in 1 year - v2.3.2): https://github.com/web-animations/web-animations-js
 * - instant-page (v5.1.0): https://github.com/instantpage/instant.page
 * - tocca (v2.0.9); https://github.com/GianlucaGuarini/Tocca.js/
 * - seamless-scroll-polyfill (v2.0.0): https://github.com/magic-akari/seamless-scroll-polyfill
 *
 * "flickity.js": v2.2.0 (with the "fade" package). Flickity is only loaded on demand if there is a product image
 * carousel on the page. Otherwise it is not loaded.
 *
 * "photoswipe": v4.1.3. PhotoSwipe is only loaded on demand to power the zoom feature on product page. If the zoom
 * feature is disabled, then this script is never loaded.
 */
/* ============================================================
 * PRE-SALE / CH LIEFERZEIT-OVERRIDE – Birthday Weeks 2026
 * Entscheidet clientseitig (wegen CDN-Caching pro Markt), welcher
 * "auf Lager"-Text angezeigt wird. Einzige Quelle der Wahrheit für
 * die SKU-Liste ist presale_skus in snippets/product-form.liquid.
 * ============================================================ */
(function () {
  function getPresaleMap(wrapper) {
    var script = wrapper.querySelector('script[data-variant-presale-map]');
    if (!script) return {};
    try {
      return JSON.parse(script.textContent);
    } catch (e) {
      return {};
    }
  }

  function updateInventoryMessage(wrapper, isPresale) {
    if (!wrapper) return;

    var badge = wrapper.querySelector('.inventory--high');
    if (!badge) return; // low stock / oversell / incoming bleiben unberührt

    var isCH = window.Shopify && window.Shopify.country === 'CH';
    var text;

    if (isPresale) {
      text = isCH ? wrapper.dataset.presaleCh : wrapper.dataset.presaleDefault;
    } else if (isCH) {
      text = wrapper.dataset.instockCh;
    } else {
      text = wrapper.dataset.instockDefault;
    }

    if (text) badge.textContent = text;
  }

  function refresh(form) {
    if (!form) return;
    var formId = form.getAttribute('id');
    if (!formId) return;

    var idInput = form.querySelector('input[name="id"]');
    var wrapper = document.querySelector('product-inventory[form-id="' + formId + '"]');
    if (!idInput || !wrapper) return;

    var presaleMap = getPresaleMap(wrapper);
    updateInventoryMessage(wrapper, !!presaleMap[idInput.value]);
  }

  function refreshAll() {
    document.querySelectorAll('form[id^="product-form-"]').forEach(refresh);
  }

  refreshAll();
  document.addEventListener('DOMContentLoaded', refreshAll);
  window.addEventListener('load', refreshAll);

  document.addEventListener('variant:changed', function (event) {
    refresh(event.target);
  });
})();

/**
 * POP-902 | Mobile PDP gallery arrows.
 *
 * Only show the arrows that actually lead somewhere: right arrow on the first image,
 * both in between, left arrow on the last. The buttons ship with the `hidden` attribute
 * so nothing flashes before this runs.
 *
 * Cell count is read from Flickity rather than product.media, so variant-filtered images
 * are accounted for automatically (a variant change destroys and rebuilds the carousel,
 * which fires flickity:ready again).
 */
(function () {
  function updateArrows(carousel) {
    if (!carousel || !carousel.flickityInstance) return;

    var nav = carousel.parentElement.querySelector('.product__media-overlay-nav');
    if (!nav) return;

    var prev = nav.querySelector('[data-action="prev"]');
    var next = nav.querySelector('[data-action="next"]');

    carousel.flickityInstance.then(function (flickity) {
      var count = flickity.cells.length;
      var index = flickity.selectedIndex;

      if (prev) prev.hidden = count < 2 || index <= 0;
      if (next) next.hidden = count < 2 || index >= count - 1;
    });
  }

  function onCarouselEvent(event) {
    var carousel = event.target;
    if (!carousel.classList || !carousel.classList.contains('product__media-list')) return;
    updateArrows(carousel);
  }

  document.addEventListener('flickity:ready', onCarouselEvent);
  document.addEventListener('flickity:slide-changed', onCarouselEvent);

  // Safety net in case a carousel was already initialised before this listener attached.
  function refreshAll() {
    document.querySelectorAll('.product__media-list').forEach(updateArrows);
  }

  refreshAll();
  document.addEventListener('DOMContentLoaded', refreshAll);
  window.addEventListener('load', refreshAll);
})();

/**
 * POP-956 – PDP video story teaser.
 *
 * The teaser (rendered in snippets/product-media.liquid) sits on top of the gallery and is
 * shown only while an image slide is selected and the video is part of the carousel (a
 * variant can filter it out). Clicking it plays the video in an overlay on top of the current
 * slide, as in the winning ABlyft variation of POP-637. The close button, Escape or a slide
 * change closes it again.
 */
(function () {
  function getTeaser(carousel) {
    var wrapper = carousel.closest('.product__media-list-wrapper');
    return wrapper ? wrapper.querySelector('.product__video-teaser') : null;
  }

  function findVideoIndex(flickity, teaser) {
    var mediaId = teaser.getAttribute('data-video-media-id');

    for (var i = 0; i < flickity.cells.length; i++) {
      if (flickity.cells[i].element.getAttribute('data-media-id') === mediaId) return i;
    }

    return -1;
  }

  function updateTeaser(carousel) {
    if (!carousel || !carousel.flickityInstance) return;

    var teaser = getTeaser(carousel);
    if (!teaser) return;

    carousel.flickityInstance.then(function (flickity) {
      var selected = flickity.selectedElement;
      var isImage = selected && selected.getAttribute('data-media-type') === 'image';

      teaser.hidden = !isImage || findVideoIndex(flickity, teaser) === -1;
    });
  }

  function openOverlay(wrapper) {
    var overlay = wrapper.querySelector('.product__video-overlay');
    if (!overlay || !overlay.hidden) return;

    overlay.insertBefore(overlay.querySelector('template').content.cloneNode(true), overlay.firstChild);
    overlay.hidden = false;
    wrapper.classList.add('is-video-overlay-open');

    // iOS Safari doesn't treat a video cloned from a template as muted, so it blocks the autoplay
    // attribute. Muting it in code and calling play() during the tap lets it start (also in Low Power Mode).
    var video = overlay.querySelector('video.product__video-overlay-player');
    if (video) {
      video.muted = true;
      video.playsInline = true;
      var playing = video.play();
      if (playing) playing.catch(function () {});
    }

    overlay.querySelector('.product__video-overlay-close').focus({ preventScroll: true });
  }

  function closeOverlay(wrapper, restoreFocus) {
    var overlay = wrapper.querySelector('.product__video-overlay');
    if (!overlay || overlay.hidden) return;

    // Removing the player stops it and starts it from the beginning next time.
    var player = overlay.querySelector('.product__video-overlay-player');
    if (player) player.remove();

    overlay.hidden = true;
    wrapper.classList.remove('is-video-overlay-open');

    var teaser = wrapper.querySelector('.product__video-teaser');
    if (restoreFocus && teaser && !teaser.hidden) teaser.focus({ preventScroll: true });
  }

  function onCarouselEvent(event) {
    var carousel = event.target;
    if (!carousel.classList || !carousel.classList.contains('product__media-list')) return;

    if (event.type === 'flickity:slide-changed') {
      closeOverlay(carousel.closest('.product__media-list-wrapper'), false);
    }

    updateTeaser(carousel);
  }

  document.addEventListener('flickity:ready', onCarouselEvent);
  document.addEventListener('flickity:slide-changed', onCarouselEvent);

  document.addEventListener('click', function (event) {
    var teaser = event.target.closest('.product__video-teaser');
    if (teaser) {
      openOverlay(teaser.closest('.product__media-list-wrapper'));
      return;
    }

    var closeButton = event.target.closest('.product__video-overlay-close');
    if (closeButton) closeOverlay(closeButton.closest('.product__media-list-wrapper'), true);
  });

  document.addEventListener('keydown', function (event) {
    if (event.key !== 'Escape') return;

    document.querySelectorAll('.product__media-list-wrapper.is-video-overlay-open').forEach(function (wrapper) {
      closeOverlay(wrapper, true);
    });
  });

  function refreshAll() {
    document.querySelectorAll('.product__media-list').forEach(updateTeaser);
  }

  refreshAll();
  document.addEventListener('DOMContentLoaded', refreshAll);
  window.addEventListener('load', refreshAll);
})();

/**
 * Coupon field in the cart drawer.
 *
 * The drawer re-renders by swapping its innerHTML on every cart change (CartDrawer._rerenderCart in theme.js), so
 * <cart-coupon> is a custom element that binds afresh in connectedCallback; what has to survive a render is kept
 * in `state`.
 *
 * Gift cards go through the tokenless Storefront API on the same cart, because /cart/update.js has no gift-card
 * field. cartGiftCardCodesAdd returns no userErrors for a code that isn't a gift card, so success is measured by
 * the number of applied gift cards going up. Liquid doesn't see gift cards, so they never re-render the drawer:
 * every gift-card answer carries the pills and the amount due, and custom.js renders them in place.
 *
 * Shopify gift-card codes are 8–20 letters and digits (generated ones: 16). Any other code is never sent to the
 * Storefront API. A 16-character code with a digit is tried as a gift card first, which spares it the discount
 * round trips; any other possible gift card is tried as a discount first. Either way both paths are tried.
 */
(function () {
  var STOREFRONT_API_VERSION = '2026-07';
  var SECTION_ID = 'mini-cart';
  var EMPTY_CART_DELAY = 300; // ms: room for an add that directly follows removing the last item

  var GIFT_CARD_CART =
    '{ id appliedGiftCards { id lastCharacters amountUsed { amount currencyCode } } cost { totalAmount { amount currencyCode } } }';
  var GIFT_CARD_PAYLOAD = '{ cart ' + GIFT_CARD_CART + ' userErrors { field message code } }';

  var GIFT_CARDS_QUERY = 'query CartCouponGiftCards($cartId: ID!) { cart(id: $cartId) ' + GIFT_CARD_CART + ' }';
  var GIFT_CARD_ADD_MUTATION =
    'mutation CartCouponGiftCardAdd($cartId: ID!, $codes: [String!]!) { cartGiftCardCodesAdd(cartId: $cartId, giftCardCodes: $codes) ' + GIFT_CARD_PAYLOAD + ' }';
  var GIFT_CARD_REMOVE_MUTATION =
    'mutation CartCouponGiftCardRemove($cartId: ID!, $ids: [ID!]!) { cartGiftCardCodesRemove(cartId: $cartId, appliedGiftCardIds: $ids) ' + GIFT_CARD_PAYLOAD + ' }';
  var GIFT_CARD_CLEAR_MUTATION =
    'mutation CartCouponGiftCardClear($cartId: ID!, $codes: [String!]!) { cartGiftCardCodesUpdate(cartId: $cartId, giftCardCodes: $codes) ' + GIFT_CARD_PAYLOAD + ' }';

  var state = { open: false, message: null };
  var enabled = false;
  var cartToken = null;
  var giftCardCount = null; // applied gift cards on cartToken's cart; null = unknown, so the next read queries
  var giftCardsLoad = null; // { token, promise }: the gift-card query in flight, shared by concurrent loads
  var emptyCleared = false;
  var emptyTimer = null;

  function request(url, init) {
    init.credentials = 'same-origin';

    return fetch(url, init).then(function (response) {
      if (!response.ok) throw new Error(url + ' ' + response.status);
      return response.json();
    });
  }

  function fetchCart() {
    return request(window.themeVariables.routes.cartUrl + '.js', {}).then(function (cart) {
      setCartToken(cart.token);
      return cart;
    });
  }

  // A new token means another cart, whose gift cards haven't been counted. This keeps giftCardCount tied to
  // cartToken, which _loadGiftCards relies on.
  function setCartToken(token) {
    if (!token) return;
    if (token !== cartToken) giftCardCount = null;
    cartToken = token;
  }

  // The cart was replaced: cartId() re-reads cart.js next time.
  function forgetCart() {
    cartToken = null;
    giftCardCount = null;
  }

  // { sections: false } skips the drawer HTML for writes that don't re-render it: rendering it costs server time.
  function updateDiscounts(codes, options) {
    var body = { discount: codes.join(',') };
    if (!options || options.sections !== false) body.sections = [SECTION_ID];

    return request(window.themeVariables.routes.cartUrl + '/update.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify(body)
    });
  }

  // All codes include ones that don't apply yet (e.g. below a minimum order value): update.js replaces the whole
  // set, so every write has to carry them or they are deleted.
  function codesOf(cart, applicableOnly) {
    return (cart.discount_codes || [])
      .filter(function (entry) {
        return entry && entry.code && !(applicableOnly && entry.applicable === false);
      })
      .map(function (entry) {
        return entry.code;
      });
  }

  function withoutCode(codes, code) {
    var key = code.toLowerCase();
    return codes.filter(function (item) {
      return item.toLowerCase() !== key;
    });
  }

  function hasCode(codes, code) {
    var key = code.toLowerCase();
    return codes.some(function (item) {
      return item.toLowerCase() === key;
    });
  }

  function refreshCart(cart) {
    document.documentElement.dispatchEvent(new CustomEvent('cart:updated', { bubbles: true, detail: { cart: cart } }));
    document.documentElement.dispatchEvent(new CustomEvent('cart:refresh', { bubbles: true, detail: { cart: cart } }));
  }

  // After a failed write the server's codes may differ from what the drawer shows. cart.js has no sections, so
  // the drawer fetches its own HTML (CartDrawer._rerenderCart's fallback).
  function resyncCart() {
    return fetchCart().then(refreshCart).catch(function () {});
  }

  function storefront(query, variables) {
    var root = (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/';

    return request(root + 'api/' + STOREFRONT_API_VERSION + '/graphql.json', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ query: query, variables: variables })
    }).then(function (json) {
      if (json.errors && json.errors.length) throw new Error(json.errors[0].message);
      return json.data;
    });
  }

  // The cart.js token is used as is (it carries "?key=…"); Shopify may change its format, so it isn't parsed.
  function cartId() {
    return (cartToken ? Promise.resolve() : fetchCart()).then(function () {
      return 'gid://shopify/Cart/' + cartToken;
    });
  }

  // The one reader of Storefront cart answers, so giftCardCount always describes cartToken's cart. A cart that
  // comes back counts even with userErrors. A stale token gets null from the query, but a new empty cart (with an
  // INVALID userError) from the mutations, so another id than the one sent counts as null too. field: the
  // mutation's payload field (a query answers with the cart itself).
  function giftCardRequest(operation, variables, field) {
    return cartId()
      .then(function (id) {
        variables.cartId = id;
        return storefront(operation, variables);
      })
      .then(
        function (data) {
          var cart = field ? data[field] && data[field].cart : data.cart;
          if (cart && cart.id !== variables.cartId) cart = null;

          if (cart) {
            giftCardCount = cart.appliedGiftCards.length;
          } else {
            forgetCart();
          }
          return cart;
        },
        function (error) {
          giftCardCount = null;
          throw error;
        }
      );
  }

  function fetchGiftCards() {
    if (giftCardsLoad && giftCardsLoad.token === cartToken) return giftCardsLoad.promise;

    var load = { token: cartToken, promise: giftCardRequest(GIFT_CARDS_QUERY, {}) };
    var clear = function () {
      if (giftCardsLoad === load) giftCardsLoad = null;
    };

    giftCardsLoad = load;
    load.promise.then(clear, clear);
    return load.promise;
  }

  // Resolves the cart when the card was added, else false. The count before is the cached one; only an unknown
  // count is queried first. A null cart (stale token, now forgotten) is retried once.
  function addGiftCard(code, isRetry) {
    var counted = giftCardCount !== null ? Promise.resolve(giftCardCount) : fetchGiftCards().then(function (cart) {
      return cart ? cart.appliedGiftCards.length : null;
    });

    return counted
      .then(function (before) {
        if (before === null) return null;

        return giftCardRequest(GIFT_CARD_ADD_MUTATION, { codes: [code] }, 'cartGiftCardCodesAdd').then(function (cart) {
          if (!cart) return null;
          return cart.appliedGiftCards.length > before ? cart : false;
        });
      })
      .then(function (added) {
        if (added !== null) return added;
        return isRetry ? false : addGiftCard(code, true);
      });
  }

  function removeGiftCard(giftCardId) {
    return giftCardRequest(GIFT_CARD_REMOVE_MUTATION, { ids: [giftCardId] }, 'cartGiftCardCodesRemove');
  }

  // Spaces and dashes are only formatting in a gift-card code.
  function compactCode(code) {
    return code.replace(/[\s-]/g, '');
  }

  function canBeGiftCard(code) {
    return /^[a-z0-9]{8,20}$/i.test(compactCode(code));
  }

  function looksGenerated(code) {
    var compact = compactCode(code);
    return /^[a-z0-9]{16}$/i.test(compact) && /\d/.test(compact);
  }

  // Storefront amounts come in the cart's presentment currency, while the theme's money formats are the shop's.
  // So the format comes from a Liquid sample in the cart currency (123456789 cents, e.g. "1.234.567,89 €"):
  // its number gives the separators and decimal count, and the rest (symbol, code, position) is kept as is.
  // Returns null when the amount isn't in the cart currency or the sample can't be read.
  function formatLikeSample(money, sample) {
    var settings = window.themeVariables && window.themeVariables.settings;
    if (!money || !sample || !settings || money.currencyCode !== settings.cartCurrency) return null;

    var number = sample.match(/\d+(?:\D\d+)*/);
    var value = parseFloat(money.amount);
    if (!number || isNaN(value)) return null;

    var separators = number[0].match(/\D/g) || [];
    var groups = number[0].split(/\D/);
    var last = separators[separators.length - 1];
    var tail = groups[groups.length - 1];
    var thousands = '';
    var decimal = '';
    var decimals = 0;

    // The last separator is the decimal one unless it is followed by 3 digits like the others ("1,234,568").
    if (separators.length && (tail.length !== 3 || (separators.length > 1 && separators[0] !== last))) {
      decimal = last;
      decimals = tail.length;
      thousands = separators.length > 1 ? separators[0] : '';
    } else if (separators.length) {
      thousands = last;
    }

    var parts = value.toFixed(decimals).split('.');
    var formatted = parts[0].replace(/\B(?=(\d{3})+(?!\d))/g, thousands) + (decimals ? decimal + parts[1] : '');

    return sample.slice(0, number.index) + formatted + sample.slice(number.index + number[0].length);
  }

  // Never rejects. Resolves { status, cart, giftCards }. status: applied | giftCard | notCombinable | rejected |
  // invalid. cart: the update.js cart of 'applied'. giftCards: the Storefront cart of a gift card added first;
  // without it the drawer queries them. A code counts as lost only if it applied before and doesn't after.
  function applyCode(code) {
    var maybeGiftCard = canBeGiftCard(code);

    // The added cart, false (not a gift card) or undefined (not tried, or a network error: left to the fallback).
    var giftCardFirst = maybeGiftCard && looksGenerated(code) ? addGiftCard(code).catch(function () {}) : Promise.resolve();

    return giftCardFirst
      .then(function (added) {
        if (added) return { status: 'giftCard', giftCards: added };
        return applyAsDiscount(maybeGiftCard && added !== false);
      })
      .catch(function () {
        return { status: 'invalid' };
      });

    function applyAsDiscount(tryGiftCard) {
      return fetchCart().then(function (cart) {
        // Already applied: shown like an invalid code; there is no separate message for it.
        if (hasCode(codesOf(cart, true), code)) return { status: 'invalid' };

        // Every restore writes back exactly this, including the typed code if the cart already had it unapplied.
        var before = codesOf(cart);
        var applicableBefore = codesOf(cart, true);

        return updateDiscounts(withoutCode(before, code).concat(code))
          .then(function (updated) {
            var applicableAfter = codesOf(updated, true);

            if (hasCode(applicableAfter, code)) {
              var lost = applicableBefore.filter(function (item) {
                return !hasCode(applicableAfter, item);
              });

              if (!lost.length) return { status: 'applied', cart: updated };

              // Restores never re-render the drawer: the message shows in place and the typed code stays.
              return updateDiscounts(before, { sections: false }).then(function () {
                return { status: 'notCombinable' };
              });
            }

            // Ajax discount codes and Storefront gift cards don't touch each other, so the restore and the gift-card
            // try run in parallel. Both finish before the result, so a failure resyncs a cart nothing still writes to.
            return Promise.allSettled([updateDiscounts(before, { sections: false }), tryGiftCard && addGiftCard(code)]).then(function (results) {
              if (results[0].status === 'rejected') throw results[0].reason;
              if (results[1].status === 'rejected') throw results[1].reason;
              return { status: results[1].value ? 'giftCard' : 'rejected' };
            });
          })
          .catch(function () {
            // A write may have gone through before the failure: show the drawer what the server has now.
            return resyncCart().then(function () {
              return { status: 'invalid' };
            });
          });
      });
    }
  }

  // Any cart change outdates the message, so the next re-render doesn't bring back an old error. Our own failure
  // paths set their message after their resync has dispatched, so it survives the re-render that resync causes.
  //
  // An emptied cart keeps its codes and gift cards; clear them so they don't come back with the next item.
  // The clear waits briefly and re-reads cart.js, so an item added right after the last one was removed (or a
  // stale event) doesn't lose its codes. emptyCleared stops a second clear until the cart has items again.
  function onCartChange(event) {
    state.message = null;

    var cart = event.detail && event.detail.cart;
    if (!cart) return;

    setCartToken(cart.token);

    if (cart.item_count !== 0) {
      emptyCleared = false;
      clearTimeout(emptyTimer);
      return;
    }

    if (!enabled || emptyCleared) return;

    clearTimeout(emptyTimer);
    emptyTimer = setTimeout(clearEmptyCart, EMPTY_CART_DELAY);
  }

  function clearEmptyCart() {
    emptyCleared = true;

    fetchCart()
      .then(function (current) {
        if (current.item_count !== 0) {
          emptyCleared = false;
          return;
        }

        var failed = false;
        function noteFailure() {
          failed = true;
        }

        // One after the other: two writes to one cart at once can let the older snapshot win.
        return (current.discount_codes && current.discount_codes.length ? updateDiscounts([], { sections: false }) : Promise.resolve())
          .catch(noteFailure)
          .then(function () {
            // null (unknown) clears too: skipping it could leave a card on the emptied cart.
            if (giftCardCount !== 0) return giftCardRequest(GIFT_CARD_CLEAR_MUTATION, { codes: [] }, 'cartGiftCardCodesUpdate');
          })
          .catch(noteFailure)
          .then(function () {
            if (failed) emptyCleared = false;
          });
      })
      .catch(function () {
        emptyCleared = false;
      });
  }

  document.addEventListener('cart:updated', onCartChange);
  document.addEventListener('cart:refresh', onCartChange);

  class CartCoupon extends HTMLElement {
    connectedCallback() {
      this.drawer = this.closest('cart-drawer') || document;
      this.toggle = this.querySelector('.cart-coupon__toggle');
      this.panel = this.querySelector('.cart-coupon__panel');
      this.input = this.querySelector('.mini-cart__discount-code-input');
      this.button = this.querySelector('.mini-cart__discount-code-button');
      this.plainMessage = this.querySelector('.cart-coupon__message:not(.cart-coupon__message--panel)');
      this.panelMessage = this.querySelector('.cart-coupon__message--panel');
      this.panelText = this.querySelector('.cart-coupon__message-text');
      this.list = this.drawer.querySelector('[data-cart-coupon-list]');
      this.total = this.drawer.querySelector('[data-cart-total]');
      this.liquidTotal = this.total ? this.total.textContent : '';
      this.busy = false;

      if (!this.toggle || !this.panel || !this.input || !this.button) return;

      enabled = true;

      this.toggle.addEventListener('click', this._onToggle.bind(this));
      this.button.addEventListener('click', this._apply.bind(this));
      this.input.addEventListener('input', this._onInput.bind(this));
      this.input.addEventListener('keydown', this._onKeydown.bind(this));
      if (this.list) this.list.addEventListener('click', this._onListClick.bind(this));

      this._setOpen(state.open);
      this._showMessage(state.message);
      this._syncButton();
      this._loadGiftCards();
    }

    _onToggle() {
      this._setOpen(!state.open);
      if (state.open) this.input.focus();
    }

    _onInput() {
      if (state.message) this._showMessage(null);
      this._syncButton();
    }

    _onKeydown(event) {
      if (event.key !== 'Enter') return;
      event.preventDefault();
      this._apply();
    }

    _setOpen(open) {
      state.open = open;
      this.panel.hidden = !open;
      this.toggle.setAttribute('aria-expanded', String(open));
      if (!open) this._showMessage(null);
    }

    _syncButton() {
      this.button.disabled = this.busy || !this.input.value.trim();
    }

    _setBusy(busy) {
      this.busy = busy;
      this.input.disabled = busy;
      this._syncButton();
    }

    // 'rejected' = neither a discount nor a gift card. With a free gift in the cart that is most likely the
    // gift's discount refusing to combine, so it gets the gift message (data-gift-conflict is only rendered then).
    _showMessage(type) {
      state.message = type;

      var text = '';
      var asPanel = false;

      if (type === 'notCombinable') {
        text = this.dataset.notCombinable;
      } else if (type === 'rejected' && this.dataset.giftConflict) {
        text = this.dataset.giftConflict;
        asPanel = true;
      } else if (type) {
        text = this.dataset.invalid;
      }

      this.classList.toggle('cart-coupon--error', !!type);

      if (this.plainMessage) {
        this.plainMessage.textContent = asPanel ? '' : text;
        this.plainMessage.hidden = !type || asPanel;
      }

      if (this.panelMessage) {
        this.panelText.textContent = asPanel ? text : '';
        this.panelMessage.hidden = !asPanel;
      }
    }

    _apply() {
      var code = this.input.value.trim();
      if (!code || this.busy) return;

      this._showMessage(null);
      this._setBusy(true);

      applyCode(code).then(
        function (result) {
          this._setBusy(false);

          if (result.status !== 'applied' && result.status !== 'giftCard') {
            this._showMessage(result.status);
            return;
          }

          this.input.value = '';
          this._syncButton();
          this._setOpen(false);

          if (result.status === 'applied') {
            refreshCart(result.cart);
          } else if (result.giftCards) {
            this._renderGiftCards(result.giftCards);
          } else {
            // Added next to a restore, so the add's amount due may predate it.
            this._loadGiftCards();
          }
        }.bind(this)
      );
    }

    _onListClick(event) {
      var button = event.target.closest('.cart-coupon__remove');
      if (!button || this.busy) return;

      var item = button.closest('.cart-coupon__item');
      var giftCardId = item.getAttribute('data-gift-card-id');
      var code = item.getAttribute('data-code');

      this.busy = true;
      button.disabled = true;

      var done = function () {
        this.busy = false;
        button.disabled = false;
      }.bind(this);

      if (giftCardId) {
        removeGiftCard(giftCardId)
          .then(this._renderGiftCards.bind(this))
          .catch(function () {})
          .then(done);
        return;
      }

      if (!code) return done();

      var invalid = function () {
        this._showMessage('invalid');
      }.bind(this);

      fetchCart()
        .then(function (cart) {
          return updateDiscounts(withoutCode(codesOf(cart), code)).then(refreshCart, function () {
            return resyncCart().then(invalid);
          });
        }, invalid)
        .then(done);
    }

    // A count of 0 skips the query: giftCardCount belongs to the current cart token, and within a page a gift
    // card can only be added from this drawer, which updates the count. A new page starts unknown and queries,
    // which picks up gift cards added in checkout. On failure the drawer keeps the Liquid totals.
    _loadGiftCards() {
      var loaded = giftCardCount === 0 ? Promise.resolve({ appliedGiftCards: [] }) : fetchGiftCards();

      return loaded.then(this._renderGiftCards.bind(this)).catch(function () {});
    }

    // cart: a Storefront cart answer. Null (stale token) keeps what is shown.
    _renderGiftCards(cart) {
      var template = this.querySelector('[data-gift-card-template]');
      if (!cart || !this.isConnected) return;

      var cards = cart.appliedGiftCards;

      if (this.list && template) {
        this.list.querySelectorAll('[data-gift-card-id]').forEach(function (item) {
          item.remove();
        });

        cards.forEach(
          function (card) {
            var item = template.content.firstElementChild.cloneNode(true);
            item.setAttribute('data-gift-card-id', card.id);
            item.querySelector('.cart-coupon__code').textContent = this.dataset.giftCardLabel.replace('[last_characters]', (card.lastCharacters || '').toUpperCase());
            var amount = formatLikeSample(card.amountUsed, this.dataset.moneySample);
            item.querySelector('.cart-coupon__savings').textContent = amount ? '−' + amount : '';
            this.list.appendChild(item);
          }.bind(this)
        );
      }

      // A total in another currency than the Liquid one (formatLikeSample returns null) keeps the Liquid total.
      if (this.total) {
        var total = cards.length ? formatLikeSample(cart.cost.totalAmount, this.dataset.moneyWithCurrencySample) : null;
        this.total.textContent = total || this.liquidTotal;
      }
    }
  }

  if (!window.customElements.get('cart-coupon')) {
    window.customElements.define('cart-coupon', CartCoupon);
  }
})();
